export default {"src":"/_next/static/media/scalpel_64.534a79ae.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};